import { useEffect } from "react";
import _ from "lodash";

import PusherManager from "utils/pusher-manager";

import { useSignedUser } from "entities/Auth/sdk";

export const useAssetManagementExcelProcessingStatusUpdates = ({
  successEventHandler,
  failureEventHandler,
}: {
  successEventHandler: () => void;
  failureEventHandler: ({ detail }: { detail: string }) => void;
}) => {
  const { data: user } = useSignedUser();

  useEffect(() => {
    if (!_.isUndefined(user)) {
      return PusherManager.bindToAssetManagementExcelProcessingSucceededEvent({
        userId: user.id,
        eventHandler: successEventHandler,
      });
    }
  }, [user, successEventHandler]);

  useEffect(() => {
    if (!_.isUndefined(user)) {
      return PusherManager.bindToAssetManagementExcelProcessingFailedEvent({
        userId: user.id,
        eventHandler: failureEventHandler,
      });
    }
  }, [user, failureEventHandler]);
};
